import { cn } from '@/lib/utils/helpers'
import companyFormStyles from '@/features/company/styles/companyAdd.module.css'
import { LIBERTY_ROLE_KEYS, PROTECTED_ROLE_KEYS } from '../constants'
import { SYSTEM_NOTE_PREFIXES } from '../constants/editPageUi'
import type { NoteItem } from '../types'

/** PMC Company / Property Info input — `companyAdd.module.css` `customFormControl`. */
export const inputClass = (err?: string) =>
  cn(
    companyFormStyles.customFormControl,
    'box-border !h-[38px] !min-h-[38px]',
    err ? '!border-red-500' : undefined,
  )

/** PMC / Application label — muted 13px Roboto. */
export const labelClass = companyFormStyles.formLabel

/** PMC field error text under inputs. */
export const fieldErrorClass = companyFormStyles.errorMessage

export const formGroupClass = companyFormStyles.formGroup

export const sectionHeadingClass =
  'mb-3 text-sm font-semibold text-slate-700 border-b border-slate-100 pb-2'

export const formFieldGridClass =
  'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-5 gap-y-4'
export const formFieldCell = 'min-w-0'
export const formFieldWide = 'sm:col-span-2 lg:col-span-2 xl:col-span-2'

export function isLibertyRoleName(roleName: string): boolean {
  return (LIBERTY_ROLE_KEYS as readonly string[]).includes(roleName)
}

export function isProtectedRoleName(roleName: string): boolean {
  return (PROTECTED_ROLE_KEYS as readonly string[]).includes(roleName)
}

export function isSystemNote(text: string): boolean {
  return SYSTEM_NOTE_PREFIXES.some((prefix) => text.startsWith(prefix))
}

export function getNoteRowId(note: NoteItem): string | number | null {
  if (note.notes_id != null && String(note.notes_id) !== '') return note.notes_id
  if (note.id != null && String(note.id) !== '') return note.id
  return null
}
